/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const StockChangeType = {
  Purchase: "PURCHASE",
  Return: "RETURN",
  Restock: "RESTOCK",
  StockRemoval: "STOCK_REMOVAL",
} as const;

export type StockChangeType =
  (typeof StockChangeType)[keyof typeof StockChangeType];

export type StockChangeTypeEnumType = typeof StockChangeType;
export type StockChangeTypeOptional = StockChangeType;
export type StockChangeTypeTrackedI = StockChangeType;
export type StockChangeTypeTracked = StockChangeType;
export type StockChangeTypeMetaI = EnumMetaType<
  StockChangeTypeEnumType,
  StockChangeType
>;
export const StockChangeTypeMeta = typeMetaEnum<
  StockChangeTypeEnumType,
  StockChangeType
>("StockChangeType", StockChangeType);
export function transformDatesStockChangeType(model: StockChangeType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
